export default (params) => {
  const { editor, focusableBlock } = params;

  const {
    value: { document },
  } = editor;

  const role = focusableBlock?.key && document.getParent(focusableBlock.key);

  if (!role) return;

  const { key: roleKey, data: roleData } = role;

  const roleDataJSON = roleData && roleData.toJSON();

  const { isCollapseChildren: isCollapseRole } = roleDataJSON || {};

  if (isCollapseRole) {
    editor
      .setNodeByKey(roleKey, {
        data: {
          ...roleDataJSON,
          isCollapseChildren: false,
        },
      })
      .blur();
  }

  const organization = roleKey && document.getParent(roleKey);

  if (!organization) return;

  const { key: organizationKey, data: organizationData } = organization;

  const organizationDataJSON = organizationData && organizationData.toJSON();

  const { isCollapseChildren: isCollapseOrganization } =
    organizationDataJSON || {};

  if (isCollapseOrganization) {
    editor
      .setNodeByKey(organizationKey, {
        data: {
          ...organizationDataJSON,
          isCollapseChildren: false,
        },
      })
      .blur();
  }
};
